class NavActionsEnum {
    static BACK = 'back';
    static NEXT = 'next';
}

export {NavActionsEnum}